

import React, { useState, useEffect, useRef } from "react";
import { TbRefresh } from "react-icons/tb";
import axios from "axios";
import { BaseUrl } from "../../../../../../api/AxiosApi";
import { Line } from "react-chartjs-2";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from "chart.js";
import DownloadJpegButton from "../../../../../../components/downloadJpegButton/DownloadJpegButton";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

export function getDateTimeForDashboardTab1(date = new Date()) {
    const formattedCurrentDate = date.toISOString().split("T")[0];
    const oneWeekAgo = new Date(date);
    oneWeekAgo.setDate(oneWeekAgo.getDate() - 7);
    const formattedOneWeekAgo = oneWeekAgo.toISOString().split("T")[0];
    return {
        Today: formattedCurrentDate,
        LastWeek: formattedOneWeekAgo,
    };
}

// 1.

// function AnalyticsTab1() {
//     const [users, setUsers] = useState([]);
//     const [selectedUser, setSelectedUser] = useState(null);
//     const [inverters, setInverters] = useState([]);
//     const [compareInverters, setCompareInverters] = useState([]);
//     const [chartData, setChartData] = useState(null);
//     const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
//     const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);
//     const [metric, setMetric] = useState("");

//     const credentials = {
//         USER_ID: localStorage.getItem("LOGIN_ID"),
//         Password: localStorage.getItem("PASSWORD"),
//         SS_KEY: localStorage.getItem("SS_KEY"),
//     };

//     // Fetch Users
//     useEffect(() => {
//         axios
//             // .get("https://log.poweramr.com/api/CMN_07_Super/GET_USER_LIST", { params: credentials })
//             .get(`${BaseUrl}CMN_07_Super/GET_USER_LIST`, { params: credentials })
//             .then((res) => setUsers(res.data.data || []))
//             .catch((err) => console.error("User API Error:", err));
//     }, []);

//     // Fetch Inverters
//     const fetchInverters = async (user) => {
//         try {
//             const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, {
//                 params: {
//                     LOGIN_ID: user.ID,
//                     LOC_CODE: user.loc_code,
//                     PASS_KEY: user.password,
//                     WEB_KEY: "WEBXYZ321",
//                     TYP: "I",
//                 },
//             });
//             setInverters(res.data.FEED || []);
//             // setCompareInverters([]);
//             setChartData(null);
//         } catch (err) {
//             console.error("Inverter API Error:", err);
//         }
//     };

//     const handleUserSelect = (user) => {
//         setSelectedUser(user);
//         fetchInverters(user);
//     };

//     const toggleCompareInverter = (inv) => {
//         if (compareInverters.find((c) => c.feeder_id === inv.feeder_id)) {
//             setCompareInverters(compareInverters.filter((c) => c.feeder_id !== inv.feeder_id));
//         } else {
//             setCompareInverters([...compareInverters, inv]);
//         }
//     };

//     const fetchChartData = async () => {
//         if (!selectedUser || compareInverters.length === 0) {
//             alert("Please select a user and at least one inverter!");
//             return;
//         }

//         try {
//             let datasets = [];
//             let labels = [];

//             for (let i = 0; i < compareInverters.length; i++) {
//                 const inv = compareInverters[i];
//                 const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
//                     params: {
//                         LOGIN_ID: selectedUser.ID,
//                         LOC_CODE: selectedUser.loc_code,
//                         PASS_KEY: selectedUser.password,
//                         WEB_KEY: "WEBXYZ321",
//                         MTR_NO: inv.feeder_id,
//                         DT1: fromDate,
//                         DT2: toDate,
//                     },
//                 });

//                 const apiData = res.data.data || [];
//                 if (apiData.length === 0) continue;

//                 const invLabels = apiData.map((d) => d.DATET || "");
//                 const values = apiData.map((d) => parseFloat(d[metric] ?? 0));
//                 if (i === 0) labels = invLabels;

//                 datasets.push({
//                     label: `${inv.name} (${selectedUser.user_name})`,
//                     data: values,
//                     borderColor: "#" + Math.floor(Math.random() * 16777215).toString(16),
//                     fill: false,
//                     tension: 0.3,
//                 });
//             }

//             if (datasets.length === 0) {
//                 alert("No data available for selected inverters and dates!");
//                 setChartData(null);
//                 return;
//             }

//             setChartData({
//                 labels,
//                 datasets,
//             });
//         } catch (err) {
//             console.error("Chart API Error:", err);
//             alert("Error fetching chart data. Check console.");
//         }
//     };

//     return (
//         <div style={{ padding: "5px 0px" }}>
//             <div style={{
//                 borderTop: "1px solid #ccc", borderRadius: "6px", padding: "5px", 
//                 backgroundColor: "white",
//                 boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
//                 transition: "border-color 0.25s ease"
//             }}>
//             <h5>Analytics Report</h5>
//             </div>


//             <div style={{
//                 display: "flex", gap: "4px",
//             }}>
//                 {/* Left: User List */}
//                 <div style={{
//                     flex: 1, minWidth: 160, border: "1px solid #ccc", borderRadius: "6px", padding: "10px", maxHeight: 180, overflowY: "auto",
//                     backgroundColor: "white",
//                     boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
//                     transition: "border-color 0.25s ease"
//                 }}>
//                     <h6>User</h6>
//                     <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
//                         {users.map((u) => (
//                             <li key={u.ID} style={{ marginBottom: "8px", display: "flex", alignItems: "center" }}>
//                                 <label style={{ display: "flex", alignItems: "center", gap: "6px" }}>
//                                     <input
//                                         type="radio"
//                                         name="user"
//                                         checked={selectedUser?.ID === u.ID}
//                                         onChange={() => handleUserSelect(u)}
//                                     />
//                                     <span style={{ fontSize: 13 }}>{u.user_name}</span>
//                                     <span style={{ color: "#888", fontSize: 12 }}>[{u.capacity}]</span>
//                                 </label>
//                             </li>
//                         ))}
//                     </ul>
//                 </div>

//                 {/* Middle: Inverters */}
//                 <div style={{
//                     flex: 1, minWidth: 180, border: "1px solid #ccc", borderRadius: "6px", padding: "10px", maxHeight: 180, overflowY: "auto",
//                     backgroundColor: "white",
//                     boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
//                     transition: "border-color 0.25s ease"
//                 }}>
//                     <h6>Inverters</h6>
//                     <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
//                         {inverters.map((inv) => (
//                             <li
//                                 key={inv.feeder_id}
//                                 style={{ display: "flex", alignItems: "center", gap: "8px", marginBottom: "5px" }}
//                             >
//                                 <input
//                                     type="checkbox"
//                                     checked={compareInverters.some((c) => c.feeder_id === inv.feeder_id)}
//                                     onChange={() => toggleCompareInverter(inv)}
//                                 />
//                                 <span style={{ fontSize: 13 }}>{inv.name}</span>
//                                 <span style={{ color: "#888", fontSize: 12 }}>[{inv.kwp}kWp]</span>
//                             </li>
//                         ))}
//                     </ul>
//                 </div>

//                 {/* Right: Compare Inverters */}
//                 <div style={{
//                     flex: 1, minWidth: 200, border: "1px solid #ccc", borderRadius: "6px", padding: "10px", maxHeight: 180, overflowY: "auto",
//                     backgroundColor: "white",
//                     boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
//                     transition: "border-color 0.25s ease"
//                 }}>
//                     <h6>Compare Inverters</h6>
//                     <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
//                         {compareInverters.map((c) => (
//                             <li key={c.feeder_id} style={{ display: "flex", alignItems: "center", gap: "5px", marginBottom: "5px" }}>
//                                 <span style={{ fontSize: 13 }}>{c.name}</span>
//                                 <span style={{ color: "#888", fontSize: 12 }}>{c.kwp}kWp</span>
//                                 <span style={{ color: "#555", fontSize: 11 }}>{selectedUser?.user_name}</span>
//                                 <button style={{ marginLeft: 2, fontSize: 11, borderRadius: "5px" }} onClick={() => toggleCompareInverter(c)}>remove</button>
//                             </li>
//                         ))}
//                     </ul>
//                 </div>
//             </div>

//             {/* Filters */}
//             <div
//                 style={{
//                     marginTop: 10,
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 12,
//                     flexWrap: "wrap",  // Allows wrapping on smaller screens
//                     backgroundColor: "#f9f9f9",
//                     padding: 12,
//                     borderRadius: 6,
//                     boxShadow: "0 2px 6px rgba(0,0,0,0.12)"
//                 }}
//             >
//                 <label
//                     style={{
//                         fontSize: 14,
//                         fontWeight: 600,
//                         borderRadius: 6,
//                         padding: "4px 8px",
//                         backgroundColor: "#e0e0e0",
//                         userSelect: "none",
//                     }}
//                 >
//                     Select Type:
//                 </label>

//                 <select
//                     value={metric}
//                     onChange={(e) => setMetric(e.target.value)}
//                     style={{
//                         fontSize: 14,
//                         height: 32,
//                         borderRadius: 6,
//                         border: "1px solid #ccc",
//                         padding: "0 10px",
//                         cursor: "pointer",
//                         backgroundColor: "white",
//                         boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
//                         transition: "border-color 0.25s ease",
//                     }}
//                 >
//                     <option value="ENG">Generation</option>
//                     <option value="CUF">CUF</option>
//                     <option value="Specific_Yield">Specific Yield</option>
//                     <option value="Specific_Power">Specific Power</option>
//                     <option value="KW_MAX">Peak Generation</option>
//                     <option value="PR">PR</option>

//                 </select>

//                 <label
//                     style={{ fontSize: 14, marginLeft: 12, minWidth: 60, fontWeight: 500 }}
//                     htmlFor="from-date"
//                 >
//                     From Date:
//                 </label>
//                 <input
//                     id="from-date"
//                     type="date"
//                     value={fromDate}
//                     onChange={(e) => setFromDate(e.target.value)}
//                     style={{
//                         fontSize: 14,
//                         borderRadius: 6,
//                         border: "1px solid #ccc",
//                         padding: "4px 10px",
//                         height: 32,
//                         cursor: "pointer",
//                         boxShadow: "inset 0 1px 3px rgba(0,0,0,0.05)",
//                         transition: "border-color 0.25s ease",
//                     }}
//                 />

//                 <label
//                     style={{ fontSize: 14, marginLeft: 12, minWidth: 40, fontWeight: 500 }}
//                     htmlFor="to-date"
//                 >
//                     To Date:
//                 </label>
//                 <input
//                     id="to-date"
//                     type="date"
//                     value={toDate}
//                     onChange={(e) => setToDate(e.target.value)}
//                     style={{
//                         fontSize: 14,
//                         borderRadius: 6,
//                         border: "1px solid #ccc",
//                         padding: "4px 10px",
//                         height: 32,
//                         cursor: "pointer",
//                         boxShadow: "inset 0 1px 3px rgba(0,0,0,0.05)",
//                         transition: "border-color 0.25s ease",
//                     }}
//                 />

//                 <TbRefresh
//                     style={{ fontSize: "1.4rem" }}
//                     onClick={fetchChartData}
//                     onMouseEnter={(e) => (e.target.style.backgroundColor = "")}
//                     onMouseLeave={(e) => (e.target.style.backgroundColor = "")}
//                 />
//             </div>

//             {chartData && (
//                 <div
//                     style={{
//                         marginTop: 10,
//                         backgroundColor: "white",
//                         boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
//                         borderRadius: 8,
//                         padding: 10,
//                         transition: "all 0.3s ease",
//                         width: "100%",      // full width of parent
//                         maxWidth: "100%",      // max width to make it compact
//                         height: 300,        // fixed height for small chart
//                         marginLeft: "auto",
//                         marginRight: "auto", // center horizontally
//                     }}
//                 >
//                     <Line
//                         data={chartData}
//                         options={{
//                             responsive: true,
//                             maintainAspectRatio: false, // allows height to control chart size
//                             plugins: {
//                                 legend: { position: "top", labels: { font: { size: 12 } } },
//                                 // title: { display: true, text: `Inverter Performance (${metric})`, font: { size: 14 } },
//                                 tooltip: { mode: "index", intersect: false },
//                             },
//                             scales: {
//                                 x: { ticks: { font: { size: 11 } } },
//                                 y: { ticks: { font: { size: 11 } } },
//                             },
//                         }}
//                     />
//                 </div>
//             )}

//         </div>
//     );
// }

// export default AnalyticsTab1;



function UserAnalyticsTab1() {
const chartRef = useRef();
    const [selectedUser, setSelectedUser] = useState(null);
    const [inverters, setInverters] = useState([]);
    const [compareInverters, setCompareInverters] = useState([]);
    const [chartData, setChartData] = useState(null);
    const [fromDate, setFromDate] = useState(getDateTimeForDashboardTab1().LastWeek);
    const [toDate, setToDate] = useState(getDateTimeForDashboardTab1().Today);
    const [metric, setMetric] = useState("ENG");
    const [loading, setLoading] = useState(false);



    // ✅ Fetch Inverters for Selected User
    // Make credentials global or at the component level
    const credentials = {
        LOGIN_ID: localStorage.getItem("LoginID"),
        LOC_CODE: localStorage.getItem("LCODE"),
        PASS_KEY: 'XYZ',
        WEB_KEY: "WEBXYZ321",
        TYP: "I",
    };

    const fetchInverters = async () => {
        try {
            console.log("Axios GET params:", credentials); // Console log the credentials here
            const res = await axios.get(`${BaseUrl}CMN_07_Super/GET_FEEDER_LIST`, { params: credentials });
            setInverters(res.data.FEED || []);
            setChartData(null);
        } catch (err) {
            console.error("Inverter API Error:", err);
        }
    };



    const handleUserSelect = (user) => {
        setSelectedUser(user);
        fetchInverters(user);
    };

    const toggleCompareInverter = (inv) => {
        setCompareInverters((prev) =>
            prev.some((c) => c.feeder_id === inv.feeder_id)
                ? prev.filter((c) => c.feeder_id !== inv.feeder_id)
                : [...prev, inv]
        );
    };

    // ✅ Fetch Performance Data
    const fetchChartData = async () => {
        if (compareInverters.length === 0) {
            alert("Please select a user and at least one inverter!");
            return;
        }

        setLoading(true);
        try {
            let datasets = [];
            let labels = [];

            for (let i = 0; i < compareInverters.length; i++) {
                const inv = compareInverters[i];
                const res = await axios.get(`${BaseUrl}CMN_08InvLog/Get_Inv_Perf`, {
                    params: {
                        LOGIN_ID: localStorage.getItem("LoginID"),
                        LOC_CODE: localStorage.getItem("LCODE"),
                        PASS_KEY: 'XYZ',
                        WEB_KEY: "WEBXYZ321",
                        MTR_NO: inv.feeder_id,
                        DT1: fromDate,
                        DT2: toDate,
                    },
                });

                const apiData = res.data.data || [];
                if (apiData.length === 0) continue;

                const invLabels = apiData.map((d) => d.DATET || d.date || "");
                const values = apiData.map((d) => parseFloat(d[metric] ?? 0));
                if (i === 0) labels = invLabels;

                datasets.push({
                    label: `${inv.name}`,
                    data: values,
                    borderColor: "#" + Math.floor(Math.random() * 16777215).toString(16),
                    fill: false,
                    tension: 0.3,
                });
            }

            if (datasets.length === 0) {
                alert("No data available for selected inverters and dates!");
                setChartData(null);
            } else {
                setChartData({ labels, datasets });
            }
        } catch (err) {
            console.error("Chart API Error:", err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchInverters();
    }, []);

    return (
        <div style={{ padding: "10px" }}>
            <div
                style={{
                    borderTop: "1px solid #ccc",
                    borderRadius: "6px",
                    padding: "8px",
                    backgroundColor: "white",
                    boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
                }}
            >
                <h5 style={{ margin: 0 }}>Analytics</h5>
            </div>

            {/* USER - INVERTER - COMPARE */}
            <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", marginTop: 10 }}>
                {/* User List */}


                {/* Inverters */}
                <div style={panelStyle}>
                    <h6>Inverters</h6>
                    <ul style={listStyle}>
                        {inverters.map((inv) => (
                            <li key={inv.feeder_id} style={listItem}>
                                <input
                                    type="checkbox"
                                    checked={compareInverters.some((c) => c.feeder_id === inv.feeder_id)}
                                    onChange={() => toggleCompareInverter(inv)}
                                />
                                <span style={nameStyle}>{inv.name}</span>
                                <span style={capStyle}>[{inv.kwp}kWp]</span>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Compare Inverters */}
                <div style={panelStyle}>
                    <h6>Compare Inverters</h6>
                    <ul style={listStyle}>
                        {compareInverters.map((c) => (
                            <li key={c.feeder_id} style={listItem}>
                                <span style={nameStyle}>{c.name}</span>
                                <span style={capStyle}>{c.kwp}kWp</span>
                                <button style={removeBtn} onClick={() => toggleCompareInverter(c)}>
                                    Remove
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>

            {/* Filters */}
            <div style={filterStyle}>
                <label style={labelStyle}>Select Type:</label>
                <select value={metric} onChange={(e) => setMetric(e.target.value)} style={selectStyle}>
                    <option value="ENG">Energy Generation</option>
                    <option value="CUF">CUF</option>
                    <option value="Specific_Yield">Specific Yield</option>
                    <option value="Specific_Power">Specific Power</option>
                    <option value="KW_MAX">Peak Generation</option>
                    <option value="PR">PR</option>
                </select>

                <label style={labelStyle}>From:</label>
                <input type="date" value={fromDate} onChange={(e) => setFromDate(e.target.value)} style={inputStyle} />

                <label style={labelStyle}>To:</label>
                <input type="date" value={toDate} onChange={(e) => setToDate(e.target.value)} style={inputStyle} />

                <TbRefresh
                    style={{ fontSize: "1.5rem", cursor: "pointer" }}
                    onClick={fetchChartData}
                    title="Refresh Chart"
                />

<DownloadJpegButton targetRef={chartRef} fileName={`General Comparison.jpeg`} />
            </div>

            {/* Chart */}
            {chartData && (
                <div
                    style={{
                        marginTop: 12,
                        backgroundColor: "white",
                        borderRadius: 8,
                        padding: 10,
                        height: 300,
                        width: "100%",
                        boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
                    }}
                    ref={chartRef} 
                >
                    <Line
                        data={chartData}
                        options={{
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                legend: { position: "top", labels: { font: { size: 12 } } },
                                // title: { display: true, text: `Inverter Performance (${metric})`, font: { size: 14 } },
                            },
                            scales: {
                                x: { ticks: { font: { size: 11 } } },
                                y: { ticks: { font: { size: 11 } } },
                            },
                        }}
                    />
                </div>
            )}
        </div>
    );
}

/* ---------- Inline Style Objects ---------- */
const panelStyle = {
    flex: 1,
    minWidth: 200,
    border: "1px solid #ccc",
    borderRadius: 6,
    padding: 10,
    maxHeight: 170,
    overflowY: "auto",
    backgroundColor: "white",
    boxShadow: "inset 0 1px 3px rgba(0,0,0,0.1)",
};

const listStyle = { listStyle: "none", padding: 0, margin: 0 };
const listItem = { display: "flex", alignItems: "center", gap: 6, marginBottom: 6 };
const nameStyle = { fontSize: 13 };
const capStyle = { color: "#888", fontSize: 12 };
const removeBtn = {
    marginLeft: "auto",
    background: "#ff5252",
    color: "white",
    border: "none",
    padding: "2px 6px",
    borderRadius: 4,
    cursor: "pointer",
    fontSize: 11,
};

const filterStyle = {
    marginTop: 10,
    display: "flex",
    alignItems: "center",
    gap: 10,
    flexWrap: "wrap",
    backgroundColor: "#f9f9f9",
    padding: 10,
    borderRadius: 6,
    boxShadow: "0 2px 6px rgba(0,0,0,0.12)",
};

const labelStyle = { fontSize: 14, fontWeight: 500 };
const inputStyle = {
    fontSize: 14,
    borderRadius: 6,
    border: "1px solid #ccc",
    padding: "4px 10px",
    height: 32,
};
const selectStyle = {
    fontSize: 14,
    borderRadius: 6,
    border: "1px solid #ccc",
    padding: "4px 10px",
    height: 32,
    backgroundColor: "white",
};

export default UserAnalyticsTab1;





